__turbopack_context__.v({
  "upload-photo-dialog-actions": "mykwqq_upload-photo-dialog-actions",
  "upload-photo-dialog-actions__button-group-container": "mykwqq_upload-photo-dialog-actions__button-group-container",
  "upload-photo-dialog-actions__delete-button-container": "mykwqq_upload-photo-dialog-actions__delete-button-container",
});
